import React from 'react';
import { Image, TouchableOpacity, Dimensions, Text, ActivityIndicator } from 'react-native';
import styled from 'styled-components/native';
import {
  WorkoutsParent,
  WorkoutContainerText,
  WorkoutTextHeader,
  WorkoutTextSubHeader,
  CerebrocoreCommonTextComponent
} from '../../styles/common-styles';

function WorkoutScience({ screenWidth }) {
  return (
      <WorkoutsContainerRight screenWidth={screenWidth}>
        <WorkoutContainerRightHeaderObj>
          <WorkoutContainerRightHeaderObjImg>
            <WorkoutContainerRightHeaderObjImgGraphic
                source={{
                  uri: `https://dev.cerebrocoreusa.com/wp-content/uploads/2023/05/CerebroCore_Icons_The-Science.png`,
                }}
                resizeMode='contain'
            />
          </WorkoutContainerRightHeaderObjImg>
          <WorkoutContainerRightHeaderObjText>
            <WorkoutTextSubHeader style={{marginBottom:6}}>
              THE SCIENCE
            </WorkoutTextSubHeader>
            <WorkoutTextHeader>
              Training your Brain
            </WorkoutTextHeader>
          </WorkoutContainerRightHeaderObjText>
        </WorkoutContainerRightHeaderObj>
        <WorkoutContainerRightText>
          <WorkoutContainerText>
            CerebroCore's Training Program utilizes targeted brain exercises paired with scientific research to engage and train your brain to reduce the risk of memory loss.
          </WorkoutContainerText>
        </WorkoutContainerRightText>
      </WorkoutsContainerRight>
  );
}

export const WorkoutsContainerRight = styled.View`
  width: ${(props) => (props.screenWidth < 768 ? '100%' : '300px')};
  height:auto;
  max-width:450px;
  background: #f8f9fb;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin-right: ${(props) => (props.screenWidth < 768 ? '0px' : '30px')};
  padding: ${(props) => (props.screenWidth < 768 ? '30px 30px 0px 30px' : '30px')};
`;

export const WorkoutContainerRightHeaderObj = styled.View`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  margin-bottom: 20px;
`;

export const WorkoutContainerRightHeaderObjImg = styled.View`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
`;

export const WorkoutContainerRightHeaderObjImgGraphic = styled.Image`
  width: 100%;
  height: 50px;
  min-width: 50px;
  max-width: 50px;
`;

export const WorkoutContainerRightHeaderObjText = styled.View`
  margin-left: 15px;
`;

export const WorkoutContainerRightHeaderObjTextSubheader = styled.Text`
  font-size: 16px;
  font-weight: 700;
  color: #c04c97;
  margin-bottom: 7.5px;
`;

export const WorkoutContainerRightHeaderObjTextHeader = styled.Text`
  font-size: 18px;
  font-weight: 700;
  color: #4573d0;
  transform: scale(1, 1.15);
  margin-top: -7.5px;
`;

export const WorkoutContainerRightText = styled.View`
  min-height:100px;
`;

export default WorkoutScience;
